/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { z } from 'zod';

import { translationKey } from '@change-corgi/core/i18n';

export const askSchema = z
	.string()
	.min(1, { message: translationKey('corgi.petition.edit.petition_content.ask.required_error') as unknown as string })
	.max(90, { message: translationKey('corgi.petition.edit.petition_content.ask.max_char_error') as unknown as string });
